import { ContainerModule } from 'inversify';
import { DashboardService, DashboardServiceSymbol } from './dashboard-service';
import { ClearDashboardState } from './listeners/clear-dashboard-state';
import { EventStreamListenerSymbol } from '@/app/event-stream';

export const dashboardModule = new ContainerModule((bind) => {
  bind<DashboardService>(DashboardServiceSymbol).to(DashboardService);

  bind(ClearDashboardState).toSelf().inSingletonScope();
  bind(EventStreamListenerSymbol).toDynamicValue((c) => c.container.get(ClearDashboardState));
});
